import { MenuItem, Stack, Typography } from '@mui/material';

import ListFilterSingleSelect from '@common/ui/ListFilters/ListFilterSingleSelect';
import { ListFilterOption } from '@common/ui/ListFilters/common';
import ListFilter from '@common/ui/ListFilters/ListFilter';
import ListFilterSelectChipTrigger from '@common/ui/ListFilters/ListFilterSelectChipTrigger';
import { useState } from 'react';
import { MaterialIcon } from '@components';

export const NEW_CONNECTOR_VALUE = '__new__';
const ADD_NEW_CONNECTOR_LABEL = 'Add new connector';

export interface SelectConnectorProps {
  options: ListFilterOption[];
  connectorOption?: ListFilterOption;
  onSelect: (connectorOption: ListFilterOption) => void;
  withDescription?: boolean;
}

export function SelectConnector({ options, connectorOption, onSelect, withDescription = true }: SelectConnectorProps) {
  const [isOpen, setIsOpen] = useState(false);

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOnSelect = (value: ListFilterOption) => {
    onSelect(value);
    closeDropdown();
  };

  return (
    <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
      <Stack direction="column" justifyContent="center" alignItems="center">
        <Typography variant="subtitle1">Select an Apono Connector</Typography>
        {withDescription && (
          <Typography variant="inputLabel" color="text.filter" textAlign="center">
            The Apono connector separates the Apono app from your environment for security purposes.
          </Typography>
        )}
      </Stack>
      <ListFilter
        trigger={
          <ListFilterSelectChipTrigger
            active={isOpen}
            label="Select Connector"
            value={connectorOption ? [connectorOption] : []}
            enableClear={false}
          />
        }
        popoverProps={{
          isOpen,
          toggleDropdown,
          closeDropdown,
        }}
        width={400}
      >
        <ListFilterSingleSelect
          width={400}
          options={options}
          value={connectorOption}
          onSelect={(val) => handleOnSelect(val)}
          enableSearch
          data-testid="select-connector"
        />

        <MenuItem
          key={NEW_CONNECTOR_VALUE}
          onClick={() => handleOnSelect({ value: NEW_CONNECTOR_VALUE, label: ADD_NEW_CONNECTOR_LABEL })}
        >
          <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={0.5}>
            <MaterialIcon symbol="add" color="primary" fontSize="small" />
            <Typography variant="buttonMedium" color="primary" component="div">
              {ADD_NEW_CONNECTOR_LABEL}
            </Typography>
          </Stack>
        </MenuItem>
      </ListFilter>
    </Stack>
  );
}
